import { render, staticRenderFns } from "./support-categories.vue?vue&type=template&id=5a4e9b9a&scoped=true&"
import script from "./support-categories.vue?vue&type=script&lang=js&"
export * from "./support-categories.vue?vue&type=script&lang=js&"
import style0 from "./support-categories.vue?vue&type=style&index=0&id=5a4e9b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e9b9a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SupportSearch: require('/opt/build/repo/storefront/components/legacy/support/support-search.vue').default,SupportCategory: require('/opt/build/repo/storefront/components/legacy/support/support-category.vue').default,SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default})
